/**
 * The gift room's conversation (recipient journey Part 4).
 *
 * After she rates (or reads to the end), the Mystic's first line arrives with
 * three branches as links inside its bubble (R4.25; the server marks them
 * `inline`, utils/inline-choices draws them). A tap on one:
 *   - a branch is counted once per tap (`gift_opener_branch`, R4.32) and then
 *     answered like any path (the Mystic reflects it and offers the card, R4.26);
 *   - any other link in a sentence is simply chosen.
 * There is no "Something else" link since 2026-10-27 (the text box covers it);
 * an old one (`focus_composer`) still only focuses the Respond box.
 */
import { track as gaTrack } from '@/utils/analytics'

export function isGiftBranch (action) {
  return !!action && action.branch_index !== undefined && action.branch_index !== null
}

export function chooseInlineLink (action, { select, focusComposer, track = gaTrack } = {}) {
  if (!action) return 'none'
  if (action.focus_composer) {
    if (focusComposer) focusComposer()
    return 'composer'
  }
  if (isGiftBranch(action)) track('gift_opener_branch', { branch_index: action.branch_index })
  if (select) select(action)
  return 'chosen'
}
